import React from 'react';
import KPICard from '../../components/shared/KPICard';
import StatusPill from '../../components/shared/StatusPill';
import SectionDivider from '../../components/shared/SectionDivider';
import IndiaMap from './IndiaMap';
import { nationalKPIs, statesData } from '../../data/mockData';

export default function NationalOverview() {
  return (
    <div className="p-6 space-y-6">
      {/* Primary KPIs — 6 cards */}
      <div className="flex gap-4">
        <KPICard title="Total Plants" value="28,450" subtext="+342 this month" subtextColor="green" />
        <KPICard title="Installed Capacity" value="9.1 GWp" subtext="Across 28 states" />
        <KPICard title="Today's Generation" value="36 GWh" subtext="+6.2% vs yesterday" subtextColor="green" />
        <KPICard title="Active Plants" value="24,318" subtext="85.4% of total" subtextColor="green" />
        <KPICard title="Offline / Fault" value="4,132" subtext="14.6% needs review" subtextColor="red" bgColor="bg-red-50" />
        <KPICard title="Avg Performance Ratio" value={`${nationalKPIs.avgPR}%`} subtext="Good zone (>72%)" subtextColor="green" />
      </div>

      {/* Map + State Table */}
      <div className="flex gap-4">
        {/* India Map */}
        <div className="w-[60%] bg-white rounded-card border border-border shadow-card p-4">
          <SectionDivider title="Generation Heatmap — India" subtitle="Click a state to drill down" />
          <div style={{ height: 430 }}>
            <IndiaMap />
          </div>
        </div>

        {/* State Summary Table */}
        <div className="flex-1 bg-white rounded-card border border-border shadow-card p-4">
          <SectionDivider title="State Summary — Today" subtitle="Top 7 states by generation" />
          <div className="overflow-x-auto">
            <table className="w-full text-xs">
              <thead>
                <tr className="border-b border-border">
                  <th className="text-left py-2 text-text-tertiary font-medium">State</th>
                  <th className="text-right py-2 text-text-tertiary font-medium">Plants</th>
                  <th className="text-right py-2 text-text-tertiary font-medium">GWh today</th>
                  <th className="text-center py-2 text-text-tertiary font-medium">Status</th>
                </tr>
              </thead>
              <tbody>
                {statesData.slice(0, 7).map(state => (
                  <tr key={state.id} className="border-b border-border/50 hover:bg-bg-secondary cursor-pointer">
                    <td className="py-2.5 font-medium text-text-primary">{state.name}</td>
                    <td className="py-2.5 text-right text-text-secondary">{state.plants.toLocaleString()}</td>
                    <td className="py-2.5 text-right font-medium text-text-primary">{state.generationGWh.toFixed(2)}</td>
                    <td className="py-2.5 text-center">
                      <StatusPill status={state.status} />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* Secondary KPIs — AVG CUF + CO₂ + MNRE Compliance */}
      <div className="flex gap-4">
        <div className="bg-white rounded-card border border-border shadow-card p-4 flex-1">
          <p className="text-xs text-text-tertiary font-medium uppercase tracking-wide">Avg CUF Today</p>
          <p className="text-xl font-bold text-text-primary mt-1">{nationalKPIs.avgCUF}%</p>
          <p className="text-xs text-text-secondary mt-1">Peak 10am–3pm</p>
        </div>
        <div className="bg-white rounded-card border border-border shadow-card p-4 flex-1">
          <p className="text-xs text-text-tertiary font-medium uppercase tracking-wide">CO₂ Offset Lifetime</p>
          <p className="text-xl font-bold text-teal mt-1">{nationalKPIs.co2OffsetMT} MT</p>
          <p className="text-xs text-text-secondary mt-1">Est. × 0.71 kg/kWh</p>
        </div>
        <div className="bg-white rounded-card border border-border shadow-card p-4 flex-1">
          <p className="text-xs text-text-tertiary font-medium uppercase tracking-wide">MNRE Compliance Score</p>
          <p className="text-xl font-bold text-success mt-1">{nationalKPIs.mnreComplianceScore}/100</p>
          <p className="text-xs text-text-secondary mt-1">National average</p>
        </div>
      </div>
    </div>
  );
}
